import React from 'react';
import { IAssembleiaAssociadoPauta } from 'store/modules/AssembleiasAssociadoReducer';
import { IAssembleiasAssessorPauta } from 'store/modules/AssembleiasAssessorReducer';
import AssembleiaPauta from './AssembleiaPauta';
import {pautasUseStyles} from './style';

export type IPauta = IAssembleiaAssociadoPauta | IAssembleiasAssessorPauta;

export interface IAssembleiaPautas {
  totalContas?: number;
  totalPresentes?: number;
  pautas?: IPauta[],
  flgVotoPresencial?: boolean;
}

export default ({ totalContas, totalPresentes, pautas, flgVotoPresencial }: IAssembleiaPautas) => {
  const classes = pautasUseStyles();
  return (
    <div className={classes.wrapper}>
      {
        pautas ? 
          pautas?.sort((pautaA: IPauta, pautaB: IPauta) => pautaA.ordem - pautaB.ordem)
            .map((pauta: IPauta, key: number) => (
              <AssembleiaPauta totalContas={totalContas} totalPresentes={totalPresentes} { ...{pauta: pauta} } flgVotoPresencial={flgVotoPresencial} key={ key } />
            ))
          : null
      }
    </div>
  );
}